var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"white no-gutters py-2 px-1 text-center"},[_c('v-col',{attrs:{"md":"12","sm":"12"}},[_c('h1',{staticClass:"pl-1 text-light font-size-3 titlesdark--text"},[_c('strong',[_vm._v(_vm._s(_vm.title))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }